<template>
  <div class="kpi-module-editor">
    <div class="editor-header">
      <div class="widget-type">
        <img
          :src="moduleConfigs.icon"
          alt="" />
        <div>{{ moduleConfigs.name }}</div>
      </div>
      <Tabs
        v-model="inputSectionTab"
        :tabs="tabs"
        :is-objects="true"
        @input="scrollToSection" />
    </div>

    <div
      class="editor"
      @scroll="throttleScroll">
      <div
        id="layout-label"
        class="editor-section">
        <h2>layout label</h2>
        <div class="body">
          <b-field
            label="Title"
            class="input-field">
            <b-input v-model="module.title" />
          </b-field>
        </div>
      </div>

      <div
        id="time-range"
        class="editor-section">
        <h2>time range</h2>
        <div class="body">
          <TableTimeRange
            v-model="module.default_time_range"
            :report-default-time-range="reportDefaultTimeRange"
            class="editor-inputs" />
        </div>
      </div>

      <div
        id="filters"
        class="editor-section">
        <h2>filters</h2>
        <div class="body">
          <FilterConfigListEditor
            v-model="module.filters"
            class="editor-inputs" />
        </div>
      </div>

      <div
        id="card-styles"
        class="editor-section">
        <h2>card styles</h2>
        <div class="body">
          <KpiModuleStyle
            v-model="module.kpi_style"
            class="editor-inputs" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Tabs from '@/components/pdf_report/Tabs.vue'
  import EditorSectionsMixin from '@/components/pdf_report/EditorSectionsMixin'
  import KpiModuleStyle from '@/components/pdf_report/kpi_module/KpiModuleStyle.vue'
  import FilterConfigListEditor from '@/components/reports/config/modules/common/FilterConfigListEditor'
  import TableTimeRange from '@/components/pdf_report/table_module/table_settings/tabs/TableTimeRange.vue'
  import { childErrors as _childErrors } from '@/components/reports/config/common/validation'

  export default {
    name: 'KpiModuleEditor',
    components: {
      Tabs,
      KpiModuleStyle,
      FilterConfigListEditor,
      TableTimeRange,
    },
    mixins: [EditorSectionsMixin,],
    props: {
      value: {
        type: Object,
        default: () => {},
      },
      errors: {
        type: Array,
        default: () => [],
      },
      reportDefaultTimeRange: {
        type: Object,
        default: null,
      },
    },
    data () {
      return {
        moduleConfigs: {
          name: 'KPIs',
          type: 'KpiModule',
          icon: require('@/assets/icons/kpi.svg'),
        },
        inputSectionTab: 'layout-label',
      }
    },
    computed: {
      module: {
        get () {
          return this.value || {}
        },
        set (value) {
          this.$emit('input', value)
        },
      },
      tabs () {
        return [
          {
            label: 'Layout Label',
            id: 'layout-label',
            hasErrors: false,
          },
          {
            label: 'Time Range',
            id: 'time-range',
            hasErrors: false,
          },
          {
            label: 'Filters',
            id: 'filters',
            hasErrors: this.childErrors('filters', this.errors).length > 0,
          },
          {
            label: 'Card Styles',
            id: 'card-styles',
            hasErrors: this.childErrors('kpi_style', this.errors).length > 0,
          },
        ]
      },
    },
    methods: {
      childErrors: _childErrors,
    },
  }
</script>

<style lang="scss" scoped>
@import '@/components/pdf_report/kpi_module/kpi-editor-panel.scss';
</style>
